import DocIndex from './DocIndex/DocIndex';
import DescriptionLists from './TailwindUI/DescriptionLists/DescriptionLists';
import FormLayouts from './TailwindUI/FormLayouts/FormLayouts';
import Navbar from './TailwindUI/Navbars/Navbar';
import PageHeadings from './TailwindUI/PageHeadings/PageHeadings';
import StackedLists from './TailwindUI/StackedLists/StackedLists';
import Pagination from './TailwindUI/Pagination/Pagination';
import Drawers from './TailwindUI/Drawers/Drawers';
import ModalDialogs from './TailwindUI/ModalDialogs/ModalDialogs';
import Avatars from './TailwindUI/Avatars/Avatars.jsx';
import Badges from './TailwindUI/Badges/Badges.jsx';
import ProductOverviews from './TailwindUI/ProductOverviews/ProductOverviews.jsx';
import ProductLists from './TailwindUI/ProductLists/ProductLists.jsx';
import CategoryPreviews from './TailwindUI/CategoryPreviews/CategoryPreviews.jsx';
import ShoppingCarts from './TailwindUI/ShoppingCarts/ShoppingCarts.jsx';
import ProductFeatures from './TailwindUI/ProductFeatures/ProductFeatures.jsx';
import PromoSections from './TailwindUI/PromoSections/PromoSections.jsx';
import CategoryFilters from './TailwindUI/CategoryFilters/CategoryFilters.jsx';

export const generalTitleMapping = {
    // General
    "/docs/documentation": "Index",
    "/docs/description-lists": "DescriptionLists",
    "/docs/page-headings": "PageHeadings",
    "/docs/stacked-lists": "StackedLists",
    "/docs/form-layouts": "FormLayouts",
    "/docs/navbars": "Navbars",
    "/docs/pagination": "Pagination",
    "/docs/drawers": "Drawers",
    "/docs/modal-dialogs": "ModalDialogs",
    "/docs/avatars": "Avatars",
    "/docs/badges": "Badges",
    "/docs/product-overviews": "ProductOverviews",
    "/docs/product-lists": "ProductLists",
    "/docs/category-previews": "CategoryPreviews",
    "/docs/shopping-carts": "ShoppingCarts",
    "/docs/product-features": "ProductFeatures",
    "/docs/promo-sections": "PromoSections",
    "/docs/category-filters": "CategoryFilters",
};

export const docComponents = {
    Index: <DocIndex />,
    DescriptionLists: <DescriptionLists />,
    PageHeadings: <PageHeadings />,
    StackedLists: <StackedLists />,
    FormLayouts: <FormLayouts />,
    Navbars: <Navbar />,
    Pagination: <Pagination />,
    Drawers: <Drawers />,
    ModalDialogs: <ModalDialogs />,
    Avatars: <Avatars />,
    Badges: <Badges />,
    ProductOverviews: <ProductOverviews />,
    ProductLists: <ProductLists />,
    CategoryPreviews: <CategoryPreviews />,
    ShoppingCarts: <ShoppingCarts />,
    ProductFeatures: <ProductFeatures />,
    PromoSections: <PromoSections />,
    CategoryFilters: <CategoryFilters />,
};
